export const workerRepeatTabs = [
    {
        id: 1,
        text: "Раз в день",
        value: 1,
    },
    {
        id: 2,
        text: "Раз в неделю",
        value: 7,
    },
    {
        id: 3,
        text: "Раз в месяц",
        value: 30,
    },
    {
        id: 4,
        text: "Раз в год",
        value: 365,
    },
    {
        id: 5,
        text: "Свой вариант",
        ownVariant: true,
    },
]
